"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ArchiveIcon = function ArchiveIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.0882 4.40925L15.589 1.91091C15.4332 1.75425 15.2215 1.66675 14.9998 1.66675H4.99984C4.77817 1.66675 4.5665 1.75425 4.41067 1.91091L1.9115 4.40925C1.75984 4.56008 1.6665 4.76841 1.6665 4.99925V15.8334C1.6665 16.7526 2.414 17.5001 3.33317 17.5001H16.6665C17.5857 17.5001 18.3332 16.7526 18.3332 15.8334V4.99925C18.3332 4.76841 18.2398 4.56008 18.0882 4.40925ZM5.34484 3.33341H14.6548L15.4873 4.16591H4.51234L5.34484 3.33341ZM3.33317 15.8334V5.83258H16.6665L16.6682 15.8334H3.33317Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.5002 9.99992H7.50016V9.16658C7.50016 8.70635 7.12707 8.33325 6.66683 8.33325C6.20659 8.33325 5.8335 8.70635 5.8335 9.16659V11.6666H14.1668V9.16658C14.1668 8.70635 13.7937 8.33325 13.3335 8.33325C12.8733 8.33325 12.5002 8.70635 12.5002 9.16659V9.99992Z",
    fill: color
  }));
};

var _default = ArchiveIcon;
exports.default = _default;